import styled from 'styled-components';
import { DownloadFileButton } from '../DownloadFileButton/DownloadFileButton';

const StyledIframeWithToolbar = styled.div<{ $height?: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${({ $height }) => $height || '700px'};
  gap: 4px;
`;

const StyledIframe = styled.iframe`
  flex: 1;
  height: 100%;
  border: 1px solid var(--grayscale-100);
`;

export type IframeWithToolbarProps = {
  fileUrl: string;
  iframeTitle?: string;
  downloadUrl?: string;
  height?: string;
};

/**
 * Iframe for viewing pdfs and other image files. Has a toolbar above with an optional download button.
 */
export const IframeWithToolbar = ({ fileUrl, downloadUrl, iframeTitle, height }: IframeWithToolbarProps) => {
  return (
    <StyledIframeWithToolbar $height={height}>
      {downloadUrl && <DownloadFileButton downloadUrl={downloadUrl} />}

      <StyledIframe
        src={fileUrl}
        title={iframeTitle}
        // ignore this element in chromatic because the async loading of the contents makes the test flaky
        data-chromatic="ignore"
      />
    </StyledIframeWithToolbar>
  );
};
